import React, { Component } from 'react';
import {Pagination} from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import { PAGE_LIMIT } from "./config";
import Overlay from "../../components/Overlay";

class BidderSpy extends Component {
    constructor() {
        super();

        this.state = {
            params: [],
            paramsObj: {},
            report: [],
            affids: null,
            pagesTotal: 0,
            activePage: 1,
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAffidBtn = this.handleAffidBtn.bind(this);
        this.handleAffidHide = this.handleAffidHide.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        const paramIndex = this.state.paramsObj[sortParam];

        report.sort((objA, objB) => {
            const valueA = objA.values[paramIndex] || 0;
            const valueB = objB.values[paramIndex] || 0;

            if(valueA > valueB) return 1 * sortOrder;
            else if(valueA < valueB) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters, type) {
        this.loadReport(filters, type);
    }

    handleAffidBtn(hash) {
        this.loadAffids(hash);
    }

    handleAffidHide() {
        this.setState({ affids: null });
    }

    loadReport(filters) {
        this.setState({ isLoading: true });

        API.BidderSpy.get(filters).then(({ params, report }) => {
            const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);
            const paramsObj = params.reduce((obj, param, index) => {
                obj[param] = index;

                return obj;
            }, {});

            this.setState({params, report, paramsObj, activePage: 1, pagesTotal, isLoading: false})
        });
    }

    loadAffids(hash) {
        this.setState({ isLoading: true });

        API.BidderSpy.getAffids(hash).then(({ affids }) =>
            this.setState({affids, isLoading: false}));
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getTable() {
        let { params, report, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table params={params} report={report} onAffidBtn={this.handleAffidBtn} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>
    }

    getAffids() {
        const { affids } = this.state;

        if(!affids) return;

        return (
            <Overlay onFormHide={this.handleAffidHide}>
                {affids.join(', ')}
            </Overlay>
        )
    }

    render() {
        const { isLoading } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder Spy"/>
                <Form onSubmit={this.handleSubmit}/>

                {this.getAffids()}
                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default BidderSpy;



// WEBPACK FOOTER //
// ./src/scenes/BidderSpy/index.js